<div class="form-group" [formGroup]="formParent">
    <textarea class="form-control" [formControlName]="'string'" rows="5" id="html-text"></textarea>
</div>